import React from 'react';
// import { Mail, Phone, MapPin, Github, Linkedin } from 'lucide-react';
// import { t } from '../utils/translations';

const Footer = ({ language }) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        {/* 푸터 메인 콘텐츠 - 실제 데이터가 생기면 사용 예정 */}
        {/* <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">{t('header.companyName', language)}</h3>
            <p className="footer-description">
              {t('footer.description', language)}
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">
              {t('footer.contact', language)}
            </h4>
            <div className="contact-info">
              <div className="contact-item">
                <Mail size={16} />
                <span>contact@ai-labc.com</span>
              </div>
              <div className="contact-item">
                <Phone size={16} />
                <span>+82-2-1234-5678</span>
              </div>
              <div className="contact-item">
                <MapPin size={16} />
                <span>
                  {t('footer.address', language)}
                </span>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-subtitle">
              {t('footer.socialMedia', language)}
            </h4>
            <div className="social-links">
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Github size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div> */}

        <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} All rights reserved.
            
            <a href="https://patriciapark.github.io/portfolio" className="footer-link">YJP</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
